import { z } from "zod";
export const skillScopeSchema = z.enum(["firm", "personal"]);
export const skillSummarySchema = z.object({
  id: z.string(),
  scope: skillScopeSchema,
  ownerUserId: z.string().nullable(),
  name: z.string(),
  nativeName: z.string(),
  description: z.string(),
  enabled: z.boolean(),
  revision: z.string(),
  version: z.number(),
  dateCreated: z.string(),
  dateModified: z.string(),
});
export const skillSchema = skillSummarySchema.extend({
  instructions: z.string(),
});
export const skillConfigSchema = z.object({
  scope: skillScopeSchema,
  name: z.string().trim().min(1).max(100),
  description: z.string().trim().min(1).max(1024),
  instructions: z.string().trim().min(1).max(64000),
  enabled: z.boolean(),
});
export type SkillScope = z.infer<typeof skillScopeSchema>;
export type SkillSummary = z.infer<typeof skillSummarySchema>;
export type Skill = z.infer<typeof skillSchema>;
export type SkillConfig = z.infer<typeof skillConfigSchema>;
